import { Grid2 as Grid } from "@mui/material";
import FanCreatorProfileItem from './fanCreatorProfileItem';
import { memo } from "react";

interface FanCreatorItemType {
  creatorItem: any;
  showForm?: boolean;
}

function FanCreatorItem(props: FanCreatorItemType) {
  const { creatorItem, showForm = false } = props || {};

  return (
    // Adjust the spacing here to ensure equal distance between rows and columns
    <Grid
      size={{
        xs: 12,
        sm: 6,
        lg: 4,
        xl: showForm ? 4 : 3,
        xxl: 3
      }}
      key={creatorItem?.creatorId}
    >
      <FanCreatorProfileItem profileData={creatorItem} />
    </Grid>
  );
}

export default memo(FanCreatorItem);
